import { useMediaQuery } from 'react-responsive';

export const useMediaType = () => {
  const isMinDesktopWidth: boolean = useMediaQuery({
    query: '(min-width: 992px)',
  });
  const isMinTabletWidth: boolean = useMediaQuery({
    query: '(min-width: 768px)',
  });

  return {
    isDesktop: isMinDesktopWidth,
    isTablet: isMinTabletWidth && !isMinDesktopWidth,
    isMobile: !isMinTabletWidth,
  };
};
